export default __webpack_public_path__ + "media/images/manual/ic/06-6a98fe677083ff07b07d73ba17120258.png";